module.exports = __webpack_public_path__ + "static/media/PL_Templates@2x.d419a364.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/performanceLeader/PL_Templates@2x.jpg
// module id = 223
// module chunks = 0